(function (global, factory) {
    typeof exports === 'object' && typeof module !== 'undefined' ? factory(exports) :
    typeof define === 'function' && define.amd ? define(['exports'], factory) :
    (global = typeof globalThis !== 'undefined' ? globalThis : global || self, factory((global.kendo = global.kendo || {}, global.kendo._globals = global.kendo._globals || {}, global.kendo._globals.AspnetmvcReady = {})));
})(this, (function (exports) {
    const __meta__ = {
        id: "aspnetmvc.ready",
        name: "AspNetMvcReady",
        category: "wrappers",
        description: "ASP.NET MVC/Core script that ensures kendo scripts/modules are ready before widget initialization.",
        depends: []
    };

    window.kendo.SYNCREADY_EVENT = "kendo:aspnetmvc:syncready";

    window.kendo.syncReady = window.kendo?.syncReady || function(cb) {
        window.addEventListener(window.kendo.SYNCREADY_EVENT, cb, { once: true });
    };

    exports.__meta__ = __meta__;

}));
